import api from '../../service/apiService'
import { apiUrl } from '../../constants/apiUrl';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from '../../service/logService';
import { InHomeUtils } from '../../util/change/inhomeUtils';
import { getDTMInit } from '../../service/dtmTag';

export const tvrecommeted = (visitId, dispatch, pageName = 'tvrecommeted', flowType = null) => {
    try {
        logOtherInfo(detailsInfo(pageName, visitId, 'tvrecommeted', "Inside tvrecommeted"));
        let UTDrecommendationinfo = apiUrl().UTDrecommendationinfo;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });

        api(UTDrecommendationinfo, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'UTD_RECOMMENDATION_INFO',
                    value: response.data
                });
            }
            //Failure Case
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                dispatch({
                    type: 'UTD_RECOMMENDATION_INFO',
                    value: null
                });
                //errorAction("LBO", pageName, "VOFailed", "applogs", visitId, dispatch, true, "VOFailed");
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState,dispatch, 'tvrecommeted');
            // }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:tvrecommeted,errorMessage:${error.message}`;
                logKafka("ERROR", "tvrecommeted", errorMsg, getErrorLogUrl, "applogs");
                // errorAction("LBO", pageName, error.message, "applogs", visitId, dispatch, true, "tvrecommeted failed");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('tvrecommeted', this.props.appState.visitId, 'tvrecommeted', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const sspUseageInfo = (visitId, dispatch, zipCode,visionCustId, pageName = 'sspUseageInfo', flowType = null) => {
    try {
        logOtherInfo(detailsInfo(pageName, visitId, 'sspUseageInfo', "Inside sspUseageInfo"));
        let UTDsspuage = apiUrl().UTDsspuage + zipCode+'&visionCustId='+visionCustId+'&visionAcctId=0001';
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        if (InHomeUtils.isNotNull(zipCode) && InHomeUtils.isNotNull(visionCustId))
        {
        api(UTDsspuage, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'SSP_USEAGE_INFO',
                    value: response.data
                });

            }
            //Failure Case
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                dispatch({
                    type: 'SSP_USEAGE_INFO',
                    value: null
                });
                //errorAction("LBO", pageName, "VOFailed", "applogs", visitId, dispatch, true, "VOFailed");
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState,dispatch, 'tvrecommeted');
            // }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:tvrecommeted,errorMessage:${error.message}`;
                logKafka("ERROR", "sspUseageInfo", errorMsg, getErrorLogUrl, "applogs");
                // errorAction("LBO", pageName, error.message, "applogs", visitId, dispatch, true, "tvrecommeted failed");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        }
    }
    catch (ex) {
        catchJSException('sspUseageInfo', this.props.appState.visitId, 'sspUseageInfo', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const setDTMDetails = (visitId, appState, daysLeft) => {
    try {
        var digitalData = { page: {}, events: [] };
        let pageEvents = {
            eventInfo: { eventName: "pageViewUpdate", timeStamp: new Date(), processed: { adobeAnalytics: false } },
            cart: {},
            page: {},
            scEvents: 'event5'
        };

        digitalData.page.pageName = 'ec| fios tv test drive| count down';
        digitalData.page.detailPageName = 'ec| fios tv test drive| count down| ' + daysLeft + ' days left';
        digitalData.page.events = "event5";
        digitalData.events.push(pageEvents);

        getDTMInit("tvRecommender", { appInfo: appState }, digitalData);
    }
    catch (ex) {
        catchJSException('tvrecommender', visitId, 'setDTMDetails', ex);
    }
}

export const PostSelectedRecommendationPlan = (selectedPlan, dispatch) => {
    dispatch({ type: 'SELECTED_RECOMM_PLAN', value: selectedPlan })
}

export const setBannerTitle = (title, dispatch) => {
    dispatch({ type: 'BANNER_TITLE', value: title })
}

export const getAtomRecommendation = (visitId, dispatch, requestInput) => {

    try {
        logOtherInfo(detailsInfo('tvRecommendation', visitId, 'tvRecommendation', "Inside Recommendation tool"));
        let url = apiUrl().ATOMUTDRecommendation;
        let request = JSON.stringify(requestInput)
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                logOtherInfo(detailsInfo('tvRecommendation', visitId, 'getAtomRecommendation', "Success"));
                dispatch({ type: 'ATOM_RECOMMENDED_TV', value: response });
            }
            else {
                logOtherInfo(detailsInfo('tvRecommendation', visitId, 'getAtomRecommendation', 'response empty'));
                dispatch({ type: 'ATOM_RECOMMENDED_TV', value: null });
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('tvRecommendation', visitId, 'getAtomRecommendation', "Exception is: " + error.message));
            });
    }
    catch (ex) {
        catchJSException('tvRecommendation', visitId, 'getAtomRecommendation', ex);
    }
}

export const setSelectedFiosFiveChannels = (visitId, dispatch, selectedChannels) =>
 {
    dispatch({ type: 'SELECTED_FIOSFIVE_CHANNELS', value: selectedChannels });
 }
 
 
export const getTestDriveRecommendations = (visitId, dispatch, pageName = 'tvRecommendation', flowType = null) => {
    try {
        logOtherInfo(detailsInfo('tvRecommender', visitId, 'getTestDriveRecommendations', "Inside getTestDriveRecommendations"));        
        let url = apiUrl().getProductEc + '/recommendedbundle';
  
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'TEST_DRIVE_RECOMM',
                    value: response.data
                });
            }
            else if (InHomeUtils.isNull(response)) {
                dispatch({
                    type: 'TEST_DRIVE_RECOMM',
                    value: null
                });
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('tvRecommender', visitId, 'getTestDriveRecommendations', "Exception is: " + error.message));

            });
    }
    catch (ex) {
        catchJSException('tvRecommender', visitId, 'getTestDriveRecommendations', ex);
    }
}

